import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";

import Gmailicon from '../assets/img/gmail.png';
import Phoneicon from '../assets/img/phone.png';
import staricon from '../assets/img/starbtn.png';

const CommonModal = ({ id }) => {

  const formRef = useRef(null);
  const [status, setStatus] = useState("");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      "service_hmrezop",      // ✅ same service ID
      "template_6qlhzgj",     // ✅ same template ID
      formRef.current,
      "1eblwEiXOqFJO88JY"      // ✅ same public key
    ).then(
      () => {
        setStatus("Message sent successfully!");
        formRef.current.reset();
      },
      () => {
        setStatus("Failed to send message. Please try again.");
      }
    );
  };

  return (
    <div
      className="modal fade"
      id={id}
      tabIndex="-1"
      aria-labelledby={`${id}Label`}
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <div className="formouter">
              <div className="formcontent">

                {/* 🔥 FORM WITH EMAILJS */}
                <form
                  ref={formRef}
                  onSubmit={sendEmail}
                  className="contact_form modalform"
                >
                  <span className="about_tag"></span>
                  <h2>Contact Us</h2>

                  <div className="row">
                    <div className="col-sm-6">
                      <input
                        type="text"
                        name="fname"
                        className="form-control name"
                        placeholder="Name"
                        required
                      />
                    </div>

                    <div className="col-sm-6">
                      <input
                        type="email"
                        name="email"
                        className="form-control email"
                        placeholder="Email"
                        required
                      />
                    </div>

                    <div className="col-sm-6">
                      <input
                        type="number"
                        name="phone"
                        className="form-control number"
                        placeholder="Phone"
                        required
                      />
                    </div>

                    <div className="col-sm-6">
                      <input
                        type="text"
                        name="inquiry"
                        className="form-control number"
                        placeholder="Courses"
                        required
                      />
                    </div>

                    <div className="col-sm-12">
                      <textarea
                        name="message"
                        className="messagebox messagembrbox "
                        placeholder="Message"
                      ></textarea>
                    </div>
                  </div>

                  {/* STATUS MESSAGE */}
                  {status && (
                    <p className="form-status">{status}</p>
                  )}

                  {/* SUBMIT BUTTON */}
                  <div data-animate="bottom" className="animeslide-desc">
                    <button type="submit" className="submit-btn">
                      <img src={staricon} alt="" /> CONNECT WITH US
                    </button>
                  </div>

                </form>
              </div>
               <div className="forminfo">
                
                {/* <a href="tel:919899604722">
                                            <img src={Phoneicon} alt="" /> +91-9899604722
                                          </a>
                                          <a href="mailto:infobhavanasingh@gmail.com">
                                            <img src={Gmailicon} alt="" /> infobhavanasingh@gmail.com
                                          </a> */}
              </div>
            </div>

            <div className="contact_bottom">
              <a href="tel:919899604722">
                <img src={Phoneicon} alt="Phone" /> +91-9899604722
              </a>
              <a href="mailto:infobhavanasingh@gmail.com">
                <img src={Gmailicon} alt="Email" className="emailbrn" />
                Infobhavanasingh@gmail.com
              </a>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default CommonModal;
